import React from 'react'
import { connect } from 'react-redux'
import { Segment, Header, Table, Button } from 'semantic-ui-react'
import styled from 'styled-components'

import OrderActions from '../../../reducers/orderReducer'
import DriverActions from '../../../reducers/driverReducer'
import MapViewActions from '../../../reducers/mapViewReducer'

import ModalAssignDriver from '../../../components/orders/ModalAssignDriver'
import Loading from '../../../components/common/loading'
import OrderAtCell from '../components/OrderListItem/OrderAtCell'
import DriverCell from './components/DriverCell'
import CustomerCell from './components/CustomerCell'
import MerchantCell from './components/MerchantCell'

import utils from '../../../utils'

const HeaderWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`

class Guide extends React.Component {
  state = {
    orderGroups: [],
    modalAssign: false,
    assignDriverData: null,
  }

  componentDidMount() {
    const { ordersLoaded, driversLoaded, syncDrivers, syncTodayOrders } = this.props

    if (!ordersLoaded) syncTodayOrders()
    if (!driversLoaded) syncDrivers()
  }

  componentDidUpdate(prevProps) {
    const { ordersLoaded: prevOrdersLoaded } = prevProps
    const { ordersLoaded } = this.props

    if (!prevOrdersLoaded && ordersLoaded) this.showMap()
  }

  onRemove = (groupIndex, orderIndex) => {
    const { orderGroups } = this.state

    const newOrderGroups = Array.from(orderGroups)

    if (newOrderGroups[groupIndex].length > 1) {
      newOrderGroups[groupIndex].splice(orderIndex, 1)
    } else {
      newOrderGroups.splice(groupIndex, 1)
    }

    this.setState({ orderGroups: newOrderGroups })
  }

  showManualAssign = groupIndex => {
    const { orders } = this.props
    const { orderGroups } = this.state

    const orderKeys = orderGroups[groupIndex]
    const selectedOrders = orderKeys.map(orderKey => orders[orderKey])

    this.setState({
      modalAssign: true,
      assignDriverData: selectedOrders,
    })
  }

  showMap = (view) => {
    const { setMapData } = this.props
    const { orderGroups } = this.state

    setMapData(view, {
      groupedOrderKeys: orderGroups.flat(),
      createNewGroup: this.createNewGroup,
    })
  }

  createNewGroup = group => {
    const { orderGroups } = this.state

    this.setState({ orderGroups: orderGroups.concat(Array(group)) })
  }

  renderHeader = () => {
    const headers = ['Group No', 'Customer', 'Restaurant', 'Driver', 'Ordered At', 'Action']

    return (
      <Table.Row>
        <Table.Cell style={{ display: 'none' }} />
        {headers.map((header, index) => (
          <Table.HeaderCell
            style={index === 0 ? { borderLeft: 'none' } : {}}
            textAlign='center'
            key={header}
          >
            {header}
          </Table.HeaderCell>
        ))}
      </Table.Row>
    )
  }

  renderBody = (groupIndex, orderIndex, order, orders) => {
    const { delivereeInProgressOrders } = this.props
    const orderCount = orders.length
    const queueOrders = orders.length > 1 && orders.slice(1)

    return (
      <Table.Row key={order.key}>
        <Table.Cell style={{ display: 'none' }} />
        {
          orderIndex === 0 && (
            <Table.Cell
              textAlign="center"
              rowSpan={orderCount}
              style={{ borderLeft: 'none' }}
            >
              {groupIndex + 1}
            </Table.Cell>
          )
        }
        <CustomerCell
          readOnly
          order={order}
          inProgressOrders={delivereeInProgressOrders[order.deliveree]
            ? delivereeInProgressOrders[order.deliveree].length
            : 0
          }
        />

        <MerchantCell order={order} readOnly />
        {
          orderIndex === 0 && (
            <DriverCell
              order={order}
              queueOrders={queueOrders}
              rowSpan={orderCount}
              showManualAssign={() => this.showManualAssign(groupIndex)}
            />
          )
        }

        <OrderAtCell order={order} readOnly />

        <Table.Cell textAlign="center">
          <Button
            color="red"
            size="mini"
            onClick={() => this.onRemove(groupIndex, orderIndex)}
          >
            Remove
          </Button>
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const { orders, orderLoading, ordersLoaded } = this.props
    const { orderGroups, modalAssign, assignDriverData } = this.state

    const mainOrder = assignDriverData && assignDriverData[0]
    const queueOrders = assignDriverData && assignDriverData.length > 1 && assignDriverData.slice(1)

    return (
      <Segment color="black">
        <Loading active={orderLoading} />
        <HeaderWrapper>
          <Header style={{ margin: 0 }} size="large">Order Guide</Header>
          <div>
            <Button onClick={() => this.showMap('order_guide_by_merchant')}>
              By Merchant
            </Button>
            <Button onClick={() => this.showMap('order_guide_by_customer')}>
              By Customer
            </Button>
          </div>
        </HeaderWrapper>
        {
          ordersLoaded && (
            <Table celled>
              <Table.Header>{this.renderHeader()}</Table.Header>
              <Table.Body>
                {
                  orderGroups.length === 0 ? (
                    <Table.Row key="no-result">
                      <Table.Cell colSpan={8} textAlign="center">
                        No results
                      </Table.Cell>
                    </Table.Row>
                  ) : (
                    orderGroups.map((orderKeys, groupIndex) => {
                      const selectedOrders = orderKeys.map(orderKey => orders[orderKey]).filter(Boolean)

                      return selectedOrders.map((order, orderIndex) => {
                        return this.renderBody(groupIndex, orderIndex, order, selectedOrders)
                      })
                    })
                  )
                }
              </Table.Body>
            </Table>
          )
        }

        <ModalAssignDriver
          action="manual"
          visible={modalAssign}
          order={mainOrder}
          queueOrders={queueOrders}
          onCancel={() => this.setState({ modalAssign: false, assignDriverData: null })}
        />
      </Segment>
    )
  }
}

const mapState = ({ orders, drivers }) => ({
  orders: utils.helpers.convertArrayToObject(orders.todayOrders.attention, 'key'),
  orderLoading: orders.todayOrdersLoading,
  ordersLoaded: orders.todayOrdersLoaded,
  drivers: drivers.drivers,
  driversLoaded: drivers.driverLoaded,
  delivereeInProgressOrders: orders.delivereeInProgressOrders,
})

const mapDispatch = {
  syncTodayOrders: OrderActions.syncTodayOrders,
  syncDrivers: DriverActions.syncDrivers,
  setMapData: MapViewActions.setMapData,
}

export default connect(mapState, mapDispatch)(Guide)



// WEBPACK FOOTER //
// ./src/containers/orders/guide/index.js